export const getToday = () => {
  return new Date().toISOString().slice(0, 10);
};

export const toAbsoluteUrl = (url) => {
  if (!url) return "";

  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }

  if (url.startsWith("/")) {
    return url;
  }

  return `/${url}`;
};

export const getContentId = (data) => {
  return (
    data?.id ||
    data?.noticeId ||
    data?.eventId ||
    data?.partnershipId ||
    data?.calendarId
  );
};

export const getInitialFileIds = (data = {}) => {
  const files = data?.files || [];

  if (!Array.isArray(files)) return [];

  return files
    .map((file) => file.fileId || file.id)
    .filter((fileId) => fileId !== undefined && fileId !== null);
};

export const getInitialImageList = (data = {}) => {
  const result = [];

  if (data?.mainImg) {
    result.push({
      imageId: "main",
      url: toAbsoluteUrl(data.mainImg),
      fileName: "기존 대표 이미지",
      isExisting: true,
      isMain: true,
    });
  }

  if (data?.imageUrl || data?.calendarImg || data?.calendarImageUrl) {
    result.push({
      imageId: "calendar",
      url: toAbsoluteUrl(
        data.imageUrl || data.calendarImg || data.calendarImageUrl
      ),
      fileName: "기존 달력 이미지",
      isExisting: true,
      isMain: true,
    });
  }

  const existingImages = data?.images || [];

  if (Array.isArray(existingImages)) {
    existingImages.forEach((image) => {
      const imageUrl =
        image?.url || image?.imageUrl || image?.fileUrl || image?.imgUrl || "";

      if (!imageUrl) return;

      result.push({
        imageId: image.imageId || image.id,
        url: toAbsoluteUrl(imageUrl),
        fileName: image.fileName || "기존 이미지",
        isExisting: true,
        isMain: false,
      });
    });
  }

  return result;
};

export const appendKeepImageIds = (formData, images = []) => {
  images
    .filter((image) => image.isExisting && !image.isMain && image.imageId)
    .forEach((image) => {
      formData.append("keepImageIds", image.imageId);
    });
};

export const appendKeepFileIds = (formData, keepFileIds = []) => {
  keepFileIds.forEach((fileId) => {
    formData.append("keepFileIds", fileId);
  });
};

export const makePreviewImage = (file, isMain = false) => {
  return {
    fileName: file.name,
    preview: URL.createObjectURL(file),
    file,
    isExisting: false,
    isMain,
  };
};